import { applyActiveTenantFromList } from '.';
import { getTenants } from '../../../api/organizations';
import type { AppThunk } from '../../../store';

export const fetchTenant = (): AppThunk<Promise<void>> => async dispatch => {
  try {
    const { data, error } = await getTenants();
    if (error) {
      throw new Error('Error when retrieving user tenant');
    }

    const tenants = data.data;
    if (!tenants?.length) {
      throw new Error('No tenants found for user');
    }

    dispatch(applyActiveTenantFromList(tenants[0]));
  } catch (error) {
    console.log('error log ', error);
  }
};
